module.exports = __webpack_public_path__ + "static/media/insulation_lcs_10y_y.4b9bf724.csv";